/* eslint-disable react-hooks/exhaustive-deps */
/// Este componente importa el hook y el componente del modal para mostrarlo al presionar el boton en la interfaz - SOLAMENTE FUNCIONA EN MOBILE ///

import React, {useEffect} from "react";

import useModal from "../../hooks/useModal";

import Modals from "../Modals/Modals";
import Filters from "./Filters";
import Translate from "../../i18n/Translate";

import useFilterPackages from "../../hooks/useFilterPackages";

import FilterIcon from "../../assets/images/icons/Filters__buttonIcon.png";

const FilterMobile = ({ setPackagesFiltered, data }) => {
  const { isVisible, toggleModal } = useModal();

  const { filteredPackets } = useFilterPackages(data);
  
  useEffect(() => {
    setPackagesFiltered(filteredPackets);
  }, [filteredPackets]);

  return (
    <>
      <div className="sport__filters-mobile">
        <button onClick={() => toggleModal()}>
          <img src={FilterIcon} alt="Filter Icon" />
          <Translate langkey="psports.filters-mobile.button" />
        </button>
      </div>

      <Modals isVisible={isVisible} hideModal={toggleModal} overflow>
        <Filters setPackagesFiltered={setPackagesFiltered} data={data} />
      </Modals>
    </>
  );
};

export default FilterMobile;
